import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';
import { getTokenValueOrString } from '../utils';

export type ThemeGenDialogConfig = {
  borderRadius?: number;
};

export function generateDialogRecipe(config?: ThemeGenDialogConfig) {
  return defineSlotRecipe({
    slots: dialogAnatomy.keys(),
    base: {
      content: {
        borderRadius: getTokenValueOrString(config?.borderRadius, 'px'),
        maxH: '80vh'
      }
    },
    variants: {
      scrollBehavior: {
        inside: {
          positioner: {
            overflow: 'hidden'
          },
          content: {
            maxH: 'calc(100% - 7.5rem)'
          },
          body: {
            overflow: 'auto'
          }
        },
        outside: {
          positioner: {
            overflow: 'auto',
            pointerEvents: 'auto'
          }
        }
      },
      size: {
        xs: {
          content: {
            maxW: 'xs'
          }
        },
        sm: {
          content: {
            maxW: 'lg'
          }
        },
        md: {
          content: {
            maxW: '2xl'
          }
        },
        lg: {
          content: {
            maxH: '70vh',
            minW: '70vw',
            maxW: '70vw'
          }
        },
        xl: {
          content: {
            maxH: '90vh',
            minW: '80vw',
            maxW: '80vw'
          }
        }
      }
    },
    defaultVariants: {
      size: 'xl',
      scrollBehavior: 'inside'
    }
  });
}
